<template>
  <div id="section-to-print" class="py-4">
    <div v-if="loading" class="text-center">
      Loading...
    </div>
    <div v-else>
      <div v-for="qr in qrs" :key="qr.code">
        <ticket-print :item="qr" class="mb-4"></ticket-print>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  data() {
    return {
      loading: false,
      loaded: false,
      qrsData: [],
      // voucher: {},
    };
  },
  mounted() {
    this.getTicketFutbol();
  },
  computed: {
    qrs() {
      return this.qrsData.map(item => this.parseUserDataObject(item, true));
    },
  },
  methods: {
    async getTicketFutbol() {
      this.loading = true;
      const { tId } = this.$route.params;
      const payload = {
        activityId: '',
        showPrinted: true,
        dniUser: tId,
      };
      const res = await api.axios.post('/search-ticket-by-event-and-document-user', payload);

      this.loaded = true;
      this.loading = false;
      this.qrsData = res.data.data;
      // this.voucher = res.data.voucher;
      // if(typeof this.voucher == "object" && Object.keys(this.voucher).length > 0) {
      //   this.voucher.siteUrl = siteUrl;
      // }
      setTimeout(() => {
        window.print();
      }, 3000);
    },
    parseUserDataObject(item, futbol) {
      if (item.userData && item.userData !== '{}') {
        let name = '';
        let lastName = '';
        let doc = '';
        let docType = '';
        let position = '';
        const pFields = JSON.parse(item.userData);
        pFields.participantFields.forEach((el) => {
          if (el.attributeInTicket === 6) {
            docType = el.value;
          }
          if (el.attributeInTicket === 2) {
            name = el.value;
          }
          if (el.attributeInTicket === 3) {
            lastName = el.value;
          }
          if (el.attributeInTicket === 4) {
            doc = el.value;
          }
          if (el.attributeInTicket === 1) {
            position = el.value;
          }
        });

        this.$set(item, 'username', `${name} ${lastName}`);
        this.$set(item, 'document', doc);

        this.$set(item, 'docType', docType);
        if (position !== '') {
          this.$set(item, 'asiento', position);
        }
      } else {
        this.$set(item, 'username', futbol ? item.name : `${item.firstName} ${item.lastName}`);
        this.$set(item, 'document', futbol ? item.num_document : item.dniUser);
        this.$set(item, 'docType', futbol ? item.type_document : item.documentType);
      }
      return item;
    },
  },
};
</script>
